import {
  ConfigurationPanel,
  ConfigurationPanelHeader,
  ConfigurationPanelBody,
  ConfigurationPanelFooter,
} from "../../Components/ConfigurationPanel";
import { Button } from "V2.0/common/button";

import useWebhookTriggerConfigForm from "./useWebhookTriggerConfigForm";
import WebhookTriggerConfigForm from "./WebhookTriggerConfigForm";

export default WebhookTriggerConfig;

function WebhookTriggerConfig(props) {
  const { node, closePanel, onSave, validationErrors, assistants, workspaceId } =
    props;

  const { formState, updateFormState, errors, validate } =
    useWebhookTriggerConfigForm(node.data, validationErrors);
  const handleSave = () => {
    if (!validate()) {
      return;
    }

    onSave(node.id, {
      ...node.data,
      ...formState,
    });

    closePanel();
  };

  return (
    <ConfigurationPanel>
      <ConfigurationPanelHeader>
        <p>Configure Webhook Trigger</p>
      </ConfigurationPanelHeader>
      <ConfigurationPanelBody>
        <WebhookTriggerConfigForm
          formState={formState}
          errors={errors}
          updateFormState={updateFormState}
          assistants={assistants}
          workspaceId={workspaceId}
        />
      </ConfigurationPanelBody>
      <ConfigurationPanelFooter>
        <div className="flex justify-end gap-x-2 items-center">
          <Button outline onClick={closePanel}>Cancel</Button>
          <Button onClick={handleSave}>Save</Button>
        </div>
      </ConfigurationPanelFooter>
    </ConfigurationPanel>
  );
}
